import { SPACES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import Icon from 'components/base/Icon';
import { Flex, Padding, Separator } from 'components/base/layout-components';
import Text from 'components/base/Text';
import styled from 'styled-components';
import { CARDS } from '../services/project-management.service';
import { LBButton } from '@linearb/buzz';

const Card = styled(Flex)`
  ${({ connected }) =>
    `border: 1px solid ${getColor(connected ? 'madang' : 'botticelli')}`};
  border-radius: 4px;
  width: 18rem;
  height: 18rem;
  ${({ connected }) => (connected ? `cursor: pointer` : '')};
  margin-right: 2rem;

  &:hover {
    ${({ connected }) =>
      connected ? 'box-shadow: 0px 0px 34px rgba(59, 89, 152, 0.2)' : ''};
  }
`;

const CardLogo = styled.img`
  height: 4rem;
`;

const Badge = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  ${({ type }) =>
    type === 'soon'
      ? `
  border: 1px solid transparent};
  background-color: transparent};
  color: ${getColor('osloGray')};`
      : `border: 1px solid ${getColor('madang')};
  background-color: ${getColor('fetaLight')};
  color: ${getColor('funGreen')};`};
`;

const Cards = ({
  history,
  connectedManagementTool,
  isOrgSettings,
  isAuthorized
}) => {
  return (
    <Padding t='x-medium'>
      <Text
        size='large'
        weight='500'
        textTransform='uppercase'
        pb={SPACES.small}
      >
        Project Management
      </Text>
      <Text size='medium' color='shuttleGray' pb={SPACES.small}>
        Connect your project management tool to LinearB to track your work and
        correlate your projects with what’s being done in Git
      </Text>
      <Separator
        width='100%'
        height='1px'
        color={getColor('catskillWhite')}
        margin='1rem 0 3rem 0'
      ></Separator>
      <Text size='medium'>Which management tool are you using?</Text>
      <Flex pt='medium'>
        {CARDS(history, isOrgSettings).map(
          ({ logo, name, sensorId, onClick }) => {
            const connected =
              connectedManagementTool &&
              connectedManagementTool.sensor_id === sensorId &&
              isAuthorized;
            return (
              <Card
                key={sensorId}
                direction='column'
                items='center'
                justify='center'
                connected={connected}
                {...(connected
                  ? {
                      onClick: () => {
                        onClick();
                      }
                    }
                  : {})}
              >
                <CardLogo src={logo} alt='' />
                <Text size='large' pb={SPACES['x-medium']} pt={SPACES.small}>
                  {name}
                </Text>
                {connected ? (
                  <Badge type='connected'>
                    <Icon
                      name='SuccessOutline'
                      size='x-small'
                      color='funGreen'
                    />
                    <Padding l='x-small'>Connected</Padding>
                  </Badge>
                ) : (
                  <LBButton
                    data-cy={`connect-${name.toLowerCase()}`}
                    variant='outline'
                    size='sm'
                    onClick={onClick}
                  >
                    Connect
                  </LBButton>
                )}
              </Card>
            );
          }
        )}
      </Flex>
    </Padding>
  );
};

export default Cards;
